export const pathnames: Record<'requiresAuth' | 'requiresNoAuth', readonly string[]> = {
  requiresAuth: [
    '/account',
    '/account/liked',
    '/account/saved',
    '/account/settings',
    '/account/keys',
    '/concepts/concept',
  ],
  requiresNoAuth: ['/auth'],
};

export const routes = {
  requiresAuth: (pathname: string) => {
    for (const route of pathnames.requiresAuth) {
      if (pathname.includes(route)) return true;
    }
    return false;
  },
  requiresNoAuth: (pathname: string) => {
    for (const route of pathnames.requiresNoAuth) {
      if (pathname.includes(route)) return true;
    }
    return false;
  },
};
